import { render, staticRenderFns } from "./ViewReceiptModal.vue?vue&type=template&id=89265310"
import script from "./ViewReceiptModal.vue?vue&type=script&lang=ts"
export * from "./ViewReceiptModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports